import { Typography } from "@mui/material";
import React, { memo } from "react";

function ChatAppContent() {
  return (
    <div
      style={{
        display: "flex", // Use flexbox for layout
        flexDirection: "column", // Stack items vertically (from top to bottom)
        alignItems: "center", // Center the items horizontally
        justifyContent: "center", // Center the items vertically
        minHeight: "20rem", // Ensure the container has a fixed height
        gap: "3rem", // Add gap between the items
      }}
    >
      <div>
        <Typography color="primary" variant="h4" fontWeight={"bold"}>
          This is your development space - enjoy!
        </Typography>
      </div>
    </div>
  );
}

export default memo(ChatAppContent);
